export default "__VITE_ASSET__41280dad__"